module.exports = __webpack_public_path__ + "static/media/trial2_1.1a996197.png";